import { EstimatedReturnsWidget } from '@/components/opportunity/estimatedReturnsWidget'
import { useSettingsContext } from '@/context/settings'
import type { StepName } from '@/types/transactionsContext'
import type { Vault } from '@/types/vault'
import { getApyValue } from '@/utils/apy'

interface ProjectedEarningsProps {
  vault: Vault
  parsedAmount: bigint
  positionValue: bigint
  tabValue: StepName
  isContainRewards: boolean
}

export const ProjectedEarnings = ({
  vault,
  parsedAmount,
  positionValue,
  tabValue,
  isContainRewards,
}: ProjectedEarningsProps) => {
  const { apyRange } = useSettingsContext()
  const { apy, asset } = vault

  if (parsedAmount === 0n && positionValue === 0n) return null

  return (
    <div className="flex flex-col gap-4 rounded-2xl border bg-surface p-4">
      <h5 className="font-medium text-base text-heading-foreground">Projected earnings</h5>
      <EstimatedReturnsWidget
        baseApy={getApyValue({ apy, apyRange, includeRewards: false })}
        containRewards={isContainRewards}
        parsedActionAmount={parsedAmount}
        positionValue={positionValue}
        token={asset}
        tabValue={tabValue}
      />
    </div>
  )
}
